import { Document, Page, Text, View, Image, StyleSheet, Font } from "@react-pdf/renderer";
import LeadFlow from '../../../Assets/Images/lead-icon-flow.png'
import FlowTwo from '../../../Assets/Images/lead-flow-two.png'

const LeaderPageDetails = () => {
  const styles = StyleSheet.create({
    page: {
      paddingHorizontal: 21,
      paddingVertical: 30,
      backgroundColor: '#FFFFFF',
      justifyContent: "space-between",
      height: '100%'
    },
    header: {
      flexDirection: 'row',
      justifyContent: 'space-between',
      borderBottom: '1px solid #00577D',
      paddingBottom: 5,
      marginBottom: 2,
      marginTop: '-15px'
    },
    titlemain: {
      fontSize: 12,
      fontWeight: 700,
      color: '#76A3BE',
    },
    title: {
      fontSize: 11,
      fontWeight: 200,
      color: '#76A3BE',
    },
    rightsection: {
      alignItems: 'flex-end',
      flexDirection: 'column',
      flex: 1,
    },
    rightText: {
      fontSize: 8,
      textAlign: 'right',
      fontWeight: 700,
      color: '#76A3BE',
    },
    rightTextsybtext: {
      fontSize: 8,
      textAlign: 'right',
      fontWeight: 700,
      color: '#76A3BE',
    },
    section: {
      marginVertical: 10,
    },
    headertext: {
      fontSize: 16,
      fontWeight: 700,
      color: '#245775',
      marginLeft: 0,
      paddingLeft: 0
    },
    paragraph: {
      fontSize: 12,
      textAlign: 'justify',
      fontWeight: 400,
      color: '#245775',
      marginBottom: 5,
      fontFamily: 'Lato',
      lineHeight: '18px',
    },
    container: {
      flexDirection: 'row',
      marginTop: 20,
      fontFamily: 'Lato',
    },
    containerrightsection: {
      marginLeft: 25,
      maxWidth: 295,
      lineHeight: '18px',
      gap: 15
    },
    image: {
      width: 231,
      height: 231,
      alignSelf: 'center',
    },
    flowimg: {
      marginTop: 30,
    },
    paragraphtopspace: {
      fontSize: 12,
      textAlign: 'justify',
      fontWeight: 400,
      color: '#245775',
      marginBottom: 5,
      fontFamily: 'Lato',
      marginTop: 12
    },
    footer: {
      width: 540,
      borderTop: '1px solid #00577D',
      paddingTop: 5,
      flexDirection: 'row',
      justifyContent: 'space-between',
      position: 'absolute',
      bottom: 15,
      left: 10,
      right: 21,
    },
    footersection: {
      flexDirection: 'column'
    },
    footerTextheading: {
      fontSize: 10,
      fontWeight: 700,
      fontFamily: 'Lato',
      color: '#76A3BE',
    },
    footerText: {
      fontSize: 8,
      fontFamily: 'Lato',
      fontWeight: 400,
      color: '#76A3BE',
    },
  });

  return (
    <View style={styles.page}>
      <View>
        {/* Header */}
        <View style={styles.header}>
          <View style={styles.headerleft}>
            <Text style={styles.titlemain}>QUADRANT FLOW</Text>
            <Text style={styles.title}>Life & Leadership Assssment</Text>
          </View>
          <View style={styles.rightsection}>
            <Text style={styles.rightText}>Rob Murray</Text>
            <Text style={styles.rightTextsybtext}>Atlas Real Estate{"\n"}Oct 18, 2024</Text>
          </View>
        </View>

        <View style={styles.container}>
            <Text style={styles.headertext}>You flow from Collaborative to Strategic</Text>
        </View> 

        {/* Content */}
        <View style={styles.section}>
          <Text style={styles.paragraph}>
            When Collaborative Leaders transition into Strategic roles, they leverage their strong foundation in fostering teamwork and mutual respect to implement more structured and goal-oriented strategies. This shift involves harnessing the trust and communication established in their collaborative role to facilitate effective planning. 
          </Text>
        </View>
        <View style={styles.container}>
          <Image src={LeadFlow} style={styles.image} />
          <View style={styles.containerrightsection}>
            <Text style={styles.paragraph}>
              Collaborative leaders already excel in understanding and balancing team dynamics, and as they transition into strategic leadership, they begin to use these insights to define precise roles, responsibilities, and benchmarks that guide the team towards achieving specific outcomes.
            </Text>
            <Text style={styles.paragraph}>
              These leaders can effectively bridge the gap between interpersonal relationships and organizational goals. This combination ensures that strategic initiatives are not only well-planned but also broadly supported. This blended approach ensures that strategic goals are pursued with a deep understanding of and commitment to the human elements that underpin organizational success.
            </Text>
          </View>
        </View> 
          <Image src={FlowTwo} style={styles.flowimg} />
      </View>
      
      {/* Footer Section */}
      <View style={styles.footer}>
        <View style={styles.footersection}>
          <Text style={styles.footerTextheading}>SELF REPORT</Text>
          <Text style={styles.footerText}>© Copyright 2025 by Dr. Rob Murray & Jack Nicholson. Published by Transformational Performance & Transformed Leader. All rights reserved.</Text>
        </View>
        <Text style={styles.footerTextheading}>PAGE</Text>
      </View>
    </View>
  );
}

export default LeaderPageDetails;